import { apiErrorBodies } from "./apiErrorBodies";

/**
 * Extracts the `details` some Tactic API errors carry next to their code
 * (`{ error: { code, message, details } }`), e.g. which shapes a map save
 * was refused for. Accepts the same error shapes as {@link getApiErrorCode}.
 *
 * @returns The details object, or `undefined` when the error carries none
 */
export function getApiErrorDetails(
  error: unknown
): Record<string, unknown> | undefined {
  for (const body of apiErrorBodies(error)) {
    const errorObj = body.error;
    if (!errorObj || typeof errorObj !== "object") continue;
    const details = (errorObj as Record<string, unknown>).details;
    if (details && typeof details === "object") {
      return details as Record<string, unknown>;
    }
  }
  return undefined;
}
